import { render } from "./AgentePickCentro.vue?vue&type=template&id=e5cf34fe"
import script from "./AgentePickCentro.vue?vue&type=script&lang=ts"
export * from "./AgentePickCentro.vue?vue&type=script&lang=ts"
script.render = render

export default script